import { useState } from "react";
import { Link } from "react-router-dom";
import { Auth } from "aws-amplify";
import { textChooser } from "../../../common/util/textChooser";
import { InfoText } from "../../../common/components/info_text";
import { Field } from "../../../common/components/controls/field";
import { FormStepCard } from "../../../common/components/form_steps";
import { generateEncryptEmail } from "../../../common/helpers/utilities";
import { ScreenProps } from "../dtos";
import Button from "../../../common/components/controls/button/styled-button";
import { RegisterFormContainer } from "./styled";

export const ConfirmScreen = ({ stateScreen, dispatchScreen }: ScreenProps) => {
  const confirmState = {
    resending: false,
    validating: false,
    code: ""
  }

  const [errors, setErrors] = useState({ code: false });
  const [state, setState] = useState(confirmState);
  // const [code, setCode] = useState("");

  const encryptedEmail = generateEncryptEmail(stateScreen.who);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const code = event.target.value.trim();

    if (code.length > 5) {
      setState({ ...confirmState, validating: true });

      Auth.confirmSignUp(stateScreen.who, code).then(() => {
        dispatchScreen({ ...stateScreen, currentScreen: 3 });
      }).catch(() => {
        setState({ ...confirmState });
        setErrors({ code: true });
      })
    }
    setState({ ...confirmState, code });
  }

  const handleResendCode = () => {
    setState({ ...confirmState, resending: true });

    Auth.resendSignUp(stateScreen.who).then(() => {

      setState({ ...confirmState, resending: false });
      setErrors({ code: false });

    }).catch(() => {

    })
  }

  const handleGoBack = () => {
    dispatchScreen({
      ...stateScreen, currentScreen: 1
    });
  }

  return (
    <FormStepCard
      className="-register"
      title={textChooser("txt49")}
      showBackButton={true}
      handleBackButton={handleGoBack}
    >
      <RegisterFormContainer>
        <InfoText
          text={textChooser("txt50", [encryptedEmail])}
          type={"plain"}
        />

        <Field
          type="text"
          hasIcon={false}
          hasError={errors.code}
          label=""
          className="-lined"
          placeholder={textChooser("txt35")}
          testId="code-register-field"
          onChange={handleOnChange}
          disabled={state.code.length > 7}
          maxLength={8}
          minLength={8}
          value={state.code}
        />
        <InfoText
          text={textChooser("txt46")}
          type="danger"
          hidden={!errors.code}
        />
        <InfoText
          text={textChooser("txt54")}
          type="danger"
          hidden={!state.validating}
        />

        <div>
          <Button
            onClick={handleResendCode}
            disabled={state.resending}
            buttonStyle="link"
            type="button"
          >
            {textChooser("txt36")}
          </Button>
        </div>

        <Link className="control-link-btn" to="/login">
          <InfoText
            text={textChooser("txt51")}
            type="info"
            medium
          />
        </Link>
      </RegisterFormContainer>
    </FormStepCard>
  )
}